import React, { useMemo } from "react";
import { icon, label, number, tooltip } from "../../../config";

/**
 * Block-assignment list, add control, and search dropdown used inside `EditProjectSidebar`.
 * `React.memo` shallow-compares props; parent supplies stable callbacks and memoized `availableBlocks`.
 */
const EditSidebarBlockAssignment = React.memo(function EditSidebarBlockAssignment({
  workCategory,
  allocation,
  availableBlocks,
  searchValue,
  showDropdown,
  dropdownRef,
  onToggleAddDropdown,
  onSearchChange,
  onAddBlock,
  onAllocationChange,
  onRemoveBlock,
}) {
  const filteredBlocks = useMemo(() => {
    if (!availableBlocks?.length) return [];
    const q = (searchValue ?? "").toLowerCase();
    return availableBlocks.filter((block) => (block.BlockName ?? "").toLowerCase().includes(q));
  }, [availableBlocks, searchValue]);

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mt-4 mb-2'>
        <span className='font-weight-light-semi-bold'>{label.BLOCK_ASSIGNMENT}</span>
        {availableBlocks?.length > number.ZERO && (
          <span
            onClick={onToggleAddDropdown}
            className='cursor-pointer'
            title={tooltip.NEW_BLOCK_ASSIGNEMENT}>
            {icon.ADD_NOTE}
          </span>
        )}
      </div>

      {showDropdown && (
        <div ref={dropdownRef} className='search-input mt-2'>
          <input
            type='text'
            placeholder='Search'
            className='input-block-assignment form-control'
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <div className='dropdown-menu'>
            {filteredBlocks.map((block) => (
              <div key={block.Id} className='dropdown-item' onClick={() => onAddBlock(block.BlockName, block.Id)}>
                {block.BlockName}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className='block-assignments-container overflow-y-auto' style={{ maxHeight: "calc(90vh - 350px)" }}>
        {workCategory.map((category, index) => (
          <div key={`${category}-${index}`} className='d-flex justify-content-between align-items-center mb-3'>
            <div className='block-label w-75' title={category}>
              {category}
            </div>
            <div className='d-flex gap-2 align-items-center justify-content-end'>
              <input
                className='allocation-input-spinner form-control w-50 text-center'
                type='number'
                min={number.ZERO}
                value={allocation[index] ?? number.ZERO}
                onChange={(e) => onAllocationChange(index, e.target.value)}
              />
              <span className='font-weight-bold'>%</span>
              <button
                type='button'
                onClick={() => onRemoveBlock(index)}
                className='btn-delete-circle cursor-pointer red border-0 app-icon-small'
                title={label.REMOVE}>
                {icon.CANCEL_FILE}
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
});

export default EditSidebarBlockAssignment;
